export default function ssss(value) {
    value = parseFloat(value)
    return value > 1000 && value <= 1000000
        ? (value / 1000).toFixed(4) + 'K'
        : value > 1000000 && value <= 1000000000
            ? (value / 1000000).toFixed(4) + 'M'
            : value > 1000000000
                ? (value / 1000000000).toFixed(4) + 'B'
                : value
}






// WEBPACK FOOTER //
// ./src/utils/kmb.js